import { Component } from '@angular/core';
import { AlertController, Loading, LoadingController, Platform, Events, ModalController, NavController, App} from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { Storage } from '@ionic/storage';
import { AuthProvider } from '../../providers/auth/auth';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';
import { CartaofidelidadePage } from "../cartaofidelidade/cartaofidelidade";

@Component({
	selector: 'page-mensagem-ponto',
	templateUrl: 'mensagem-ponto.html',
})
export class MensagemPontoPage {
	loading: Loading;
	id         = 0;
	empresa    = "";
	imagem     = "";
	id_empresa = 0;
	carregando = true;
	wpp_result = {code: 0};
	wpp_message = {code: 0};

	constructor(
		public navCtrl: NavController, private alertCtrl: AlertController, private loadingCtrl: LoadingController, private _apiService: ApiProvider, private storage: Storage, public modalCtrl : ModalController, private _auth: AuthProvider, public push: Push, private _msg: TranslateMsgProvider, public platform: Platform, public events: Events, public appCtrl: App) { }

	// Executar sempre que a página for aberta, mesmo se for voltando
	ionViewDidEnter()
	{
		var env = this;
		this._auth.confirmaLogin();
		this._auth.checkempresa();
		this.showLoading();
		this.storage.get('result-message').then(function(wpp_message){
			if(wpp_message){
				console.log("mensagem do servidor: ", wpp_message);
				// env.wpp_result.code = code;
				env.wpp_message = wpp_message;
				env.storage.remove('result-message');
			}
		});
		if(this.id == 0)
		{
			// Primeiro pega o id do cliente
			this.storage.get('id_cliente').then((val) => {
				this.id = val;
				this.getConfigs();
			});
		}
		else{
			this.getConfigs();
		}
	}
	// Pega as configurações
	getConfigs()
	{
		this.carregando = true;
		this.storage.get('id_empresa_escolhida').then((val) => {
				this.id_empresa = val;
			// Pega as configurações padrões (textoes e etc)
			this._apiService.getConfig({id_empresa_escolhida:this.id_empresa, id_cliente:this.id}).subscribe(arg =>{
				console.log(arg);
				this.empresa = arg['nomeEmpresa'];
				this.imagem  = arg['imagem'];
				this.carregando = false;
                this.loading.dismiss();
			});
		});
	}
	/* Exibe as mensagens de erro ou sucesso */
	showPopup(title, text) {
		this.loading.dismiss();
		let alert = this.alertCtrl.create({
			title   : title,
			subTitle: text,
			buttons : [{text: 'OK'}]
		});
		alert.present();
	}
	/* Exibe mensagem de loading*/
	showLoading() {
		this.loading = this.loadingCtrl.create({content: this._msg.getMsg('CARREGANDO')+'...'});
		this.loading.present();
	}

	meuCartao(){
		this.storage.set("id_empresa_escolhida", this.id_empresa);
		this.navCtrl.push(CartaofidelidadePage);
	}

	
}



// WEBPACK FOOTER //
// ./src/pages/mensagem-ponto/mensagem-ponto.ts